import { Hire as H } from "./Listing";
export default function Hire() { return <H />; }
